<template>
  <b-card :title="`크리에이터 후원 이벤트 ${pageTypeText}`" body-class="create-creator-event-card">
    <b-row class="mb-2">
      <b-col>모든 필수항목 값이 설정되어야 캠페인 {{ pageTypeText }}이 가능합니다.</b-col>
      <b-col class="col-auto"><span style="color:red;">*</span>필수 항목</b-col>
    </b-row>
    <div v-if="isCreatorEventLoaded">
      <b-form-group label-cols="2" horizontal>
        <template slot="label">
          게임명
        </template>
        <b-form-select id="app-select" :state="selectedAppMasterApp !== null" :disabled="!isCreatePage" v-model="selectedAppMasterApp" :options="appMasterAppList">
        </b-form-select>
        <b-form-invalid-feedback id="app-select-feedback">
          ! 게임을 선택해주세요! 해당 게임의 카프카 DB 등록여부도 확인해주세요.
        </b-form-invalid-feedback>
        <b-form-text id="app-select-help">
          선택한 게임이 지니의 카프카 DB에 등록되어있는지 여부를 확인해주세요. 미등록시 이벤트 진행이 불가능합니다. ( 확인부서: <a href="https://kakaogames.agit.in/g/300018190/wall" target="_blank">서비스기획3팀</a>
          )
        </b-form-text>
      </b-form-group>
      <b-form-group label-cols="2" label-align-sm="right" horizontal>
        <template slot="label">
          <span style="color:red;">*</span> 이벤트명
        </template>
        <b-form-input id="event-name" maxlength="40" v-model="creatorEvent.name" :state="validateEventName(creatorEvent)">

        </b-form-input>
        <b-form-invalid-feedback id="event-name-feedback">
          이벤트명을 입력해주세요.
        </b-form-invalid-feedback>
        <b-form-text id="event-name-help">
          유저 화면에서 노출되지 않으며, 어드민에서 사용하는 관리용 이벤트명입니다.
        </b-form-text>
      </b-form-group>
      <b-form-group label-cols="2" label-align-sm="right" horizontal>
        <template slot="label">
          <span style="color:red;">*</span> 코드네임
        </template>
        <b-form-input id="code-name" v-model="creatorEvent.codeName" :disabled="!isCreatePage" :state="validateCodeName(creatorEvent)">

        </b-form-input>
        <b-form-invalid-feedback id="code-name-feedback">
          코드네임을 입력해주세요.
        </b-form-invalid-feedback>
        <b-form-text id="code-name-help">
          사용자 접속 url에 사용되는 코드네임입니다.
        </b-form-text>
      </b-form-group>
      <b-form-group label-cols="2" horizontal>
        <template slot="label">
          <span style="color:red;">*</span> 크리에이터<br>신청 기간
        </template>
        <b-row>
          <b-col>
            <date-picker :class="isValidFormControlClass(validateCreatorApplicableTime(creatorEvent))" v-model="creatorEvent.creatorApplicableStartTime"
                         :config="dateOptions"></date-picker>
          </b-col>
          <b-col class="col-auto">
            ~
          </b-col>
          <b-col>
            <date-picker :class="isValidFormControlClass(validateCreatorApplicableTime(creatorEvent))" v-model="creatorEvent.creatorApplicableEndTime"
                         :config="dateOptions"></date-picker>
          </b-col>
        </b-row>
        <div class="invalid-feedback" :style="{display:validateCreatorApplicableTime(creatorEvent) ? 'none' : 'block'}">
          집행 기간을 확인하세요. 시작일은 종료일 이전으로 설정되어야 합니다.
        </div>
      </b-form-group>
      <b-form-group label-cols="2" horizontal>
        <template slot="label">
          <span style="color:red;">*</span> 응원포인트<br>결제적립 기간
        </template>
        <b-row>
          <b-col>
            <date-picker :class="isValidFormControlClass(validatePaymentAccruedTime(creatorEvent))" v-model="creatorEvent.paymentAccruedStartTime"
                         :config="dateOptions"></date-picker>
          </b-col>
          <b-col class="col-auto">
            ~
          </b-col>
          <b-col>
            <date-picker :class="isValidFormControlClass(validatePaymentAccruedTime(creatorEvent))" v-model="creatorEvent.paymentAccruedEndTime"
                         :config="dateOptions"></date-picker>
          </b-col>
        </b-row>
        <div class="invalid-feedback" :style="{display:validatePaymentAccruedTime(creatorEvent) ? 'none' : 'block'}">
          집행 기간을 확인하세요. 시작일은 종료일 이전으로 설정되어야 합니다.
        </div>
        <b-form-text>
          게임내 결제로 인해 응원포인트가 적립되는 기간입니다.
        </b-form-text>
      </b-form-group>
      <b-form-group label-cols="2" horizontal>
        <template slot="label">
          최초 적립 안내<br>알림톡 발송
        </template>
        <b-form-radio-group v-model="creatorEvent.isSendFirstPaymentAlimtalk">
          <b-form-radio :value="true">
            사용
          </b-form-radio>
          <b-form-radio :value="false">
            사용 안함
          </b-form-radio>
        </b-form-radio-group>
        <b-form-text>
          응원포인트 적립기간내에 게임내 결제시 응원포인트가 적립되면서 해당 유저에게 실시간으로 발송되는 적립 안내 알림톡입니다.<br>
          최초 적립되는 1회만 발송되며 이후 발송되지 않으며 별도의 수신동의, 수신철회 절차는 없습니다.
          <a href="#" v-b-modal="'alimtalk-preview-modal'" @click="e=>e.preventDefault()"> 알림톡 미리보기</a>
        </b-form-text>
        <b-modal id="alimtalk-preview-modal" title="알림톡 미리보기" size="xl" ok-only ok-title="닫기">
          <img src="data:image/png;base64,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">
        </b-modal>
      </b-form-group>
      <b-form-group label-cols="2" horizontal>
        <template slot="label">
          <span style="color:red;">*</span> 응원포인트<br>응원(후원) 기간
        </template>
        <b-row>
          <b-col>
            <date-picker :class="isValidFormControlClass(validateDonationTime(creatorEvent))" v-model="creatorEvent.donationStartTime"
                         :config="dateOptions"></date-picker>
          </b-col>
          <b-col class="col-auto">
            ~
          </b-col>
          <b-col>
            <date-picker :class="isValidFormControlClass(validateDonationTime(creatorEvent))" v-model="creatorEvent.donationEndTime"
                         :config="dateOptions"></date-picker>
          </b-col>
        </b-row>
        <div class="invalid-feedback" :style="{display:validatePaymentAccruedTime(creatorEvent) ? 'none' : 'block'}">
          집행 기간을 확인하세요. 시작일은 종료일 이전으로 설정되어야 합니다.
        </div>
        <b-form-text>
          유저가 적립예정과 응원포인트를 확인하고 응원(후원)할 수 있는 기간이며, 결제적립 종료 이후에도 응원(후원)할 수 있도록 설정할 수 있습니다.
        </b-form-text>
        <br>
        <b-row>
          <b-col>
            <b-input-group prepend="1회 최소 :" append="P">
              <b-form-input :state="validateDonationMinAmount(creatorEvent)" type="number" v-model="creatorEvent.donationMinAmount"></b-form-input>
            </b-input-group>
            <div class="invalid-feedback" :style="{display:validateDonationMinAmount(creatorEvent) ? 'none' : 'block'}">
              10p ~ 100p내의 수치를 입력해주세요.
            </div>
          </b-col>
          <b-col>
            <b-input-group prepend="크리에이터 1인 최대 :" append="P">
              <b-form-input :state="validateCreatorMaxAmount(creatorEvent)" type="number" v-model="creatorEvent.creatorMaxAmount"></b-form-input>
            </b-input-group>
            <div class="invalid-feedback" :style="{display:validateCreatorMaxAmount(creatorEvent) ? 'none' : 'block'}">
              1,000p ~ 1,000,000p내의 수치를 입력해주세요.
            </div>
          </b-col>
        </b-row>
        <b-form-text>
          결제금액 1,000원에 1p가 적립되며, 1,000원 미만의 금액은 절삭됩니다.
        </b-form-text>
      </b-form-group>
      <b-form-group label-cols="2" horizontal>
        <template slot="label">
          <span style="color:red;">*</span> 정산 종료
        </template>
        <date-picker :class="isValidFormControlClass(!validateEndTime(creatorEvent))" v-model="creatorEvent.eventEndTime" :config="dateOptions"></date-picker>
        <div class="invalid-feedback" :style="{display:!validateEndTime(creatorEvent) ? 'none' : 'block'}">
          {{validateEndTime(creatorEvent)}}
        </div>
        <b-form-text>
          결제 환불 처리(응원포인트의 차감)의 종료 일정으로, 실제 지급되는 지원금이 확정되는 일정과 동일하게 설정해주세요.
        </b-form-text>
      </b-form-group>
    </div>
    <div class="w-100 text-center">
      <b-button class="mr-3" :to="{name:'CreatorPromotionEventList'}">
        취소
      </b-button>
      <b-button variant="primary" @click="submit">
        {{ pageTypeText }}
      </b-button>
    </div>
  </b-card>
</template>

<script>
import creatorPromotionApi from "@/common/creatorPromotion/api/creatorPromotionApi";

export default {
  name: "CreatorEventCreate",

  props: {
    pageType: {
      type: 'create' | 'edit',
      default: 'create'
    }
  },

  data() {
    return {
      isCreatorEventLoaded: false,
      creatorEvent: {
        name: "",
        appId: "",
        appName: "",
        codeName: "",
        eventStartTime: "",
        eventEndTime: "",
        creatorApplicableStartTime: "",
        creatorApplicableEndTime: "",
        paymentAccruedStartTime: "",
        paymentAccruedEndTime: "",
        donationStartTime: "",
        donationEndTime: "",
        isSendFirstPaymentAlimtalk: false,
        donationMinAmount: 0,
        creatorMaxAmount: 0
      },
      dateOptions: {
        format: 'YYYY-MM-DD HH:mm',
        sideBySide: true,
      },
      appMasterAppList: [],
      selectedAppMasterApp: null
    }
  },

  async mounted() {
    await creatorPromotionApi.getApps().then(response => {
      this.appMasterAppList = [{text: "게임을 선택해주세요.", value: null}];
      this.appMasterAppList.push(
          ...response.data.data
              .filter(elm => !!elm.capriAppId)  //카프리 앱 아이디가 있는 것들만 추리기
              .map(elm => {
                return {
                  text: elm.description + "(" + elm.capriAppId + ")",
                  value: elm
                }
              }));
    });

    if (this.isCreatePage) {
      this.isCreatorEventLoaded = true;
    } else {
      await creatorPromotionApi.getCreatorEvent(this.$router.currentRoute.params.id)
          .then(response => {
            if (response.data.apiResultCode === 200) {
              this.creatorEvent = response.data.data;
              this.selectedAppMasterApp = this.appMasterAppList.find(elm => elm.value && elm.value.capriAppId === this.creatorEvent.appId.toString()).value;
              this.isCreatorEventLoaded = true;
            }
          });
    }

    if (this.isCreatorEventLoaded === false) {
      alert("크리에이터 이벤트 정보를 불러올 수 없습니다.(삭제 또는 없는 이벤트 id)");
    }
  },

  computed: {
    isCreatePage() {
      return this.pageType === 'create';
    },
    pageTypeText() {
      return this.isCreatePage ? "등록" : "수정";
    }
  },

  methods: {
    isValidFormControlClass(valid) {
      return {
        "is-valid": valid,
        "is-invalid": !valid
      }
    },

    submit() {
      if(!this.selectedAppMasterApp){
        alert("앱을 선택하세요.");
        return;
      }
      this.creatorEvent.appId = this.selectedAppMasterApp.capriAppId;
      this.creatorEvent.appName = this.selectedAppMasterApp.description;
      this.creatorEvent.eventStartTime = this.creatorEvent.creatorApplicableStartTime;

      const createCreatorEventData = {
        ...this.creatorEvent
      }
      if (this.validateCreatorEvent(createCreatorEventData) === false) {
        return;
      }

      (this.isCreatePage ? creatorPromotionApi.createCreatorEvent(createCreatorEventData)
                         : creatorPromotionApi.updateCreatorEvent(createCreatorEventData))
          .then(response => {
            if (response.data.apiResultCode === 200) {
              alert(`${this.pageTypeText}되었습니다.`);
              this.$router.push({name: "CreatorPromotionEventList"})
            } else {
              alert(response.data.msg);
            }
          })
          .catch(error => {
            alert(error.response.msg);
          });
    },

    validateCreatorEvent(creatorEvent) {
      if(!creatorEvent.name){
        alert("이벤트명을 입력하세요.")
        return false;
      }

      if(!creatorEvent.appId){
        alert("앱을 선택하세요.")
        return false;
      }

      if(!creatorEvent.codeName){
        alert("코드네임을 입력하세요.")
        return false;
      }

      if(!this.validateDonationMinAmount(creatorEvent)){
        alert("1회 최소 응원 금액을 확인해주세요.")
        return false;
      }

      if(!this.validateCreatorMaxAmount(creatorEvent)){
        alert("크리에이터 1인 최대 응원 금액을 확인해주세요.")
        return false;
      }

      //크리에이터 신청 기간
      if (!this.validateCreatorApplicableTime(creatorEvent)) {
        alert("크리에이터 신청 시작 시간이 종료 시간보다 뒤에 있습니다.");
        return false;
      }

      //응원포인트 결제 적립 기간
      if (!this.validatePaymentAccruedTime(creatorEvent)) {
        alert("응원포인트 결제 적립 기간 시작 시간이 종료 시간보다 뒤에 있습니다.");
        return false;
      }

      if (creatorEvent.paymentAccruedStartTime < creatorEvent.creatorApplicableStartTime) {
        alert("응원포인트 결제 적립 기간 시작 시간이 크리에이터 신청 시작 시간보다 앞에 있습니다.");
        return false;
      }

      //응원기간
      if (!this.validateDonationTime(creatorEvent)) {
        alert("응원포인트 응원(후원) 기간 시작 시간이 종료 시간보다 뒤에 있습니다.");
        return false;
      }

      //정산종료는 전부 뒤로
      const validateEndTimeMessge = this.validateEndTime(creatorEvent);
      if(validateEndTimeMessge){
        alert(validateEndTimeMessge);
        return false;
      }

      return true;
    },

    validateCreatorApplicableTime(creatorEvent) {
      if (!creatorEvent.creatorApplicableStartTime || !creatorEvent.creatorApplicableEndTime) {
        return false;
      }
      return (creatorEvent.creatorApplicableStartTime <= creatorEvent.creatorApplicableEndTime);
    },

    validatePaymentAccruedTime(creatorEvent) {
      if (!creatorEvent.paymentAccruedStartTime || !creatorEvent.paymentAccruedEndTime) {
        return false;
      }
      return (creatorEvent.paymentAccruedStartTime <= creatorEvent.paymentAccruedEndTime);
    },

    validateDonationTime(creatorEvent) {
      if (!creatorEvent.donationStartTime || !creatorEvent.donationEndTime) {
        return false;
      }
      return (creatorEvent.donationStartTime <= creatorEvent.donationEndTime);
    },

    /***
     *
     * @param creatorEvent
     * @return {string|null} null일때 valid하다. string이면 오류 메시지
     */
    validateEndTime(creatorEvent){
      //정산종료는 전부 뒤로
      if (creatorEvent.donationEndTime > creatorEvent.eventEndTime) {
        return "응원포인트 응원(후원) 기간 종료 시간이 정산 종료 시간보다 뒤에 있습니다.";
      }
      if (creatorEvent.paymentAccruedEndTime > creatorEvent.eventEndTime) {
        return "응원포인트 결제 적립 기간 종료 시간이 정산 종료 시간보다 뒤에 있습니다.";
      }
      if (creatorEvent.creatorApplicableEndTime > creatorEvent.eventEndTime) {
        return "크리에이어 신청 기간 종료 시간이 정상 종료 시간보다 뒤에 있습니다.";
      }
      return null;
    },

    validateEventName(creatorEvent) {
      return creatorEvent.name.length > 0;
    },

    validateCodeName(creatorEvent) {
      return creatorEvent.codeName.length > 0;
    },

    validateDonationMinAmount(creatorEvent){
      return (10 <= creatorEvent.donationMinAmount && creatorEvent.donationMinAmount <= 100);
    },

    validateCreatorMaxAmount(creatorEvent){
      return (1000 <= creatorEvent.creatorMaxAmount && creatorEvent.creatorMaxAmount <= 1000000);
    }
  }
}
</script>

<style>
.create-creator-event-card .col-form-label {
  text-align: right;
}

.create-creator-event-card .b-form-group:first-child {
  border-top: 2px solid grey;
  padding-top: 1rem;
}

.create-creator-event-card .b-form-group + .b-form-group {
  border-top: 1px solid #E0E0E0;
  padding-top: 1rem;
}

.create-creator-event-card .b-form-group:last-child {
  border-bottom: 2px solid grey;
  padding-bottom: 1rem;
}

</style>
